export default __webpack_public_path__ + "static/media/cart1.2cc027b3.gif";